import { useEffect, useMemo } from 'react';
import { setFieldValue, setFieldValidatorDelegate, setFieldTouched } from '@icp/form-renderer-core';
import { useDispatch } from '../../store/StoreProvider';

export default function useActAsField(fieldInfo) {
  const { id, component, title, defaultValue } = fieldInfo;

  const dispatch = useDispatch();

  const setValidatorDelegate = useMemo(
    () => (validator) => {
      dispatch(setFieldValidatorDelegate({ keyPath: id, validator }));
    },
    [dispatch, id],
  );

  const api = useMemo(() => {
    const setTouched = () => {
      dispatch(setFieldTouched({ keyPath: id, touched: true }));
    };
    const setValue = (v) => {
      return dispatch(setFieldValue({ keyPath: id, value: v, fromUI: true }));
    };

    return { setTouched, setValue, id, name: title, defaultValue };
  }, [dispatch, id, title, defaultValue]);

  useMemo(() => {
    setValidatorDelegate({
      [Symbol.for('validation')]: {
        id,
        title,
        component,
        validation: { tryDelegate: true },
      },
    });
  }, [id, title, component, setValidatorDelegate]);

  useEffect(() => {
    return () => {
      setValidatorDelegate(undefined);
    };
  }, [setValidatorDelegate]);

  return [api, setValidatorDelegate];
}

export const EmptyApi = {
  setTouched: () => {},
  setValue: () => {},
  id: null,
  name: null,
  defaultValue: null,
};
